'use client';

import { Dialog, DialogContent, DialogDescription, DialogTitle } from '@shared/components/shadcn';
import { useTranslations } from 'next-intl';
import { SearchContainer } from '../../SearchContainer';

type SearchDialogProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
};

/**
 * SearchDialog component that displays the search dialog. It will display the search input and the search results.
 *
 * @param open - Whether the dialog is open
 * @param onOpenChange - The function to call when the dialog is opened or closed
 * @returns A Dialog with the search input and the search results
 */
function SearchDialog({ open, onOpenChange }: SearchDialogProps) {
  const t = useTranslations('general.search');
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogTitle className="sr-only">{t('placeholder')}</DialogTitle>
      <DialogDescription className="sr-only overflow-y-hidden">{t('placeholder')}</DialogDescription>
      <DialogContent role="search" showCloseButton={false} className="p-12 max-h-[calc(100vh-72px)] flex flex-col gap-0 md:top-9 md:translate-y-0">
        <SearchContainer placeholder={t('placeholder')} variant="dialog" searchType="all" onCancel={() => onOpenChange(false)} className="w-full" />
      </DialogContent>
    </Dialog>
  );
}

export { SearchDialog };
